const createTabsSx = {
	'& .ant-tabs-nav': {
		marginBottom: '24px',
	},
	'& .ant-tabs-nav::before': {
		borderBottom: '1px solid #D9D9D9',
	},
	'& .ant-tabs-nav-list': {
		gap: 0,
	},
	'& .ant-tabs-nav-wrap': {
		paddingTop: '2px',
	},
	'& .ant-tabs-tab': {
		padding: '0 16px 12px !important',
		margin: '0 !important',
		lineHeight: 1.35,
		background: 'transparent !important',
		border: 'none !important',
		boxShadow: 'none !important',
		transition: 'color 0.2s ease, background-color 0.2s ease',
	},
	'& .ant-tabs-tab + .ant-tabs-tab': {
		margin: '0 !important',
	},
	'& .ant-tabs-tab-btn': {
		color: '#616161 !important',
		fontSize: '14px',
		fontWeight: 500,
		lineHeight: 1.35,
		background: 'transparent',
		textShadow: 'none !important',
	},
	'& .ant-tabs-tab:hover': {
		background: 'transparent !important',
	},
	'& .ant-tabs-tab:hover .ant-tabs-tab-btn': {
		color: '#616161 !important',
	},
	'& .ant-tabs-tab.ant-tabs-tab-active': {
		background: 'transparent !important',
	},
	'& .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn': {
		color: '#185FA5 !important',
		fontSize: '14px',
		fontWeight: 500,
		textShadow: 'none',
	},
	'& .ant-tabs-ink-bar': {
		height: '2px',
		background: '#185FA5',
		borderRadius: '999px',
	},
	'& .ant-tabs-content-holder': {
		overflow: 'visible',
	},
};

export default createTabsSx;
